import React from "react";

const ModamilyAppScrollBarOptions = ({ children }) => {
  return <div className="scrollbar-options">{children}</div>;
};

export default ModamilyAppScrollBarOptions;
